// 预订api
import http from './http';

const getService = (requestUrl, params?, config?) => {
  return http({
    ...config,
    method: 'GET',
    url: requestUrl,
    params,
  });
};

const postService = (requestUrl, data?, config?) => {
  return http({
    ...config,
    method: 'POST',
    url: requestUrl,
    data,
  });
};

const deleteService = (requestUrl, data?, config?) => {
  return http({
    ...config,
    method: 'DELETE',
    url: requestUrl,
    data,
  });
};

// 预订提交检查
const checkReserve = (data) => postService('/reservation/check', data);

// 预订单提交
const createReserve = (data) => postService('/reservation/create', data);

// 预订单暂存
const stashReserve = (data) => postService('/reservation/temp', data);

// 预订暂存详情
const getStashDetail = (resvNo) => getService(`/reservation/temp/detail/${resvNo}`);

// 查询预订详情
const getReserveDetail = (resvNo) => getService(`/reservation/detail/${resvNo}`);

// 删除暂存预订
const deleteTempOrder = (resvNo) => deleteService(`/reservation/temp/${resvNo}`);

// 强制删除暂存预订
const removeTempOrder = (resvNo) => deleteService(`/reservation/temp/remove/${resvNo}`);

// 追加预订
const appendReserve = (data) => postService('/reservation/append', data);

// 取消预订单详情
const getReserveCancelDetail = (data) => postService('/reservations/cancel/detail', data);

// 取消预订单
const cancelReserve = (data) => postService('/reservations/cancel', data);

// 预订换房信息
const getReserveExchangeDetail = (recNo) => getService(`/rooms/change/detail/${recNo}`);

// 查询房型价格
const getRoomMarketPrice = (data) => postService('/channels/type/info', data);

// 预订换房
const submitReserveExchange = (data) => postService('/rooms/change/reservation/submit', data);

// 条件查询字典列表
const getDictListByType = (data) => postService(`/dict/list/by-type?code=${data.code}`, {});

// 查询续住修改过的订单
const getModifiedOrderList = (id) => getService(`/extension/updated/${id}`);

// 查询返还预订详情
const getRollbackOrderDetail = (id) => getService(`/extension/rollback/detail/${id}`);

export default {
  getReserveDetail,
  checkReserve,
  createReserve,
  stashReserve,
  getStashDetail,
  deleteTempOrder,
  appendReserve,
  getReserveCancelDetail,
  cancelReserve,
  getReserveExchangeDetail,
  getRoomMarketPrice,
  submitReserveExchange,
  removeTempOrder,
  getDictListByType,
  getModifiedOrderList,
  getRollbackOrderDetail,
};
